import { useMediaQuery } from '@ui-components/global/useMediaQuery'
const MIN_SCREEN_WIDTH_FOR_LONG_SERVICE_NAME = 355
const MIN_SCREEN_WIDTH_FOR_LONG_SERVICE_NAME_WITH_SECONDARY_NAME = 500

export const useShouldShowServiceName = (hasSecondaryName: boolean): boolean => {
  return useMediaQuery(
    `(min-width: ${hasSecondaryName ? MIN_SCREEN_WIDTH_FOR_LONG_SERVICE_NAME_WITH_SECONDARY_NAME : MIN_SCREEN_WIDTH_FOR_LONG_SERVICE_NAME}px)`,
  )
}
